let misgeret_swatches = document.querySelectorAll('.misgeret_swatch input')
let misgeret_swatches_containers = document.querySelectorAll('.misgeret_swatch')
let selected_color = document.querySelector('.misgeret_swatch_selected_value')
let misgeret_image = document.querySelector('.misgeret_image img')

if (misgeret_swatches && selected_color && misgeret_swatches_containers) {
  misgeret_swatches.forEach((swatch, index) => {
    swatch.addEventListener('change', () => {
      if (swatch.checked)
        selected_color.innerText = misgeret_swatches_containers[index].getAttribute('data-option')
        misgeret_image.setAttribute('src', misgeret_swatches_containers[index].getAttribute('data-image'))
    })
  })
}